import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Square with diagonal feature.
 *
 * Verifiable properties:
 * - Diagonals are equal length (d = s * sqrt(2))
 * - Diagonals are perpendicular
 * - Diagonals bisect each other
 */
export const SQUARE_FEATURES_PRESET: GeometryPadWidgetConfig = {
  id: 'square-features',
  type: 'geometrypad',
  params: {
    elements: {
      sq1: {
        type: 'Square',
        params: { s: 5 },
      },
      'diagonal.sq1': { type: 'Diagonal', params: { of: 'sq1' } },
    },
  },
  display: {},
};
